<template>
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="40"
      height="40"
      rx="20"
      fill="#FFF7F2"
    />
    <g clip-path="url(#clip0_3657_1609)">
      <path
        d="M9.47401 11.31C9.70801 13.112 10.509 16.952 10.872 18.573C10.967 19.032 11.073 19.426 11.17 19.586C11.671 20.451 12.077 19.299 12.077 19.299C13.644 14.616 11.17 11.597 10.38 10.787C10.241 10.637 9.99601 10.455 9.77201 10.391C9.45201 10.296 9.39801 10.477 9.39801 10.627C9.40801 10.775 9.46301 11.192 9.47301 11.309L9.47401 11.31ZM31.309 9.84704C31.619 10.071 32.695 11.202 31.309 11.373C29.325 11.607 25.549 11.746 19.287 16.983C16.92 18.968 11.607 24.311 8.76001 30.957C8.74324 30.9981 8.71199 31.0316 8.67217 31.0511C8.63235 31.0707 8.58674 31.0749 8.54401 31.063C8.28901 30.989 7.83001 30.711 8.06401 29.645C8.38401 28.205 11.265 20.707 18.881 14.093C21.366 11.938 27.297 6.86104 31.307 9.84804L31.309 9.84704Z"
        fill="#040325"
      />
    </g>
    <defs>
      <clipPath id="clip0_3657_1609">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(8 8)"
        />
      </clipPath>
    </defs>
  </svg>
</template>
